import type { CollapseProps } from "antd";
import GeneralInfo from "./Info";
import ForceUpdateSettings from "./ForceUpdateSettings";

export const EditMobileAppVersionConstants = {
	GENERAL_INFO: "Genel Bilgiler",
	FORCE_UPDATE: "Force Update Ayarları"
};

export const MobileAppVersionItems: CollapseProps["items"] = [
	{
		key: "1",
		label: EditMobileAppVersionConstants.GENERAL_INFO,
		children: <GeneralInfo />,
	},	
	{
		key: "2",
		label: EditMobileAppVersionConstants.FORCE_UPDATE,
		children: <ForceUpdateSettings />,
	},
];
